import Vue from 'vue'
import VueRouter from 'vue-router'

const Home = () => import('../views/Home.vue')
const ShowOff = () => import('../views/ShowOff.vue')
const Wallpapers = () => import('../views/Wallpapers.vue')
const Work = () => import('../views/Work.vue')
const Plans = () => import('../views/Plans.vue')
const About = () => import('../views/About.vue')
const Bound = () => import('../views/Bound.vue')
const Uiwork = () => import('../views/Uiwork.vue')
const Dhanam = () => import('../views/Dhanam.vue')
const Ecolpore = () => import('../views/Ecoplore.vue')
const Vasundhra = () => import('../views/Vasundhra.vue')
const Battlestations = () => import('../views/Battlestations.vue')
const Healinggarden = () => import('../views/Healinggarden.vue')
const Cobold = () => import('../views/Cobold.vue')
const Zsites = () => import('../views/Zsites.vue')
const PetFood = () => import('../views/PetFood.vue')
const ZsitesLanding = () => import('../views/ZsitesLanding.vue')
const Max = () => import('../views/Max.vue')
const Swastik = () => import('../views/Swastik.vue')
const CardDemo = () => import('../views/CardDemo.vue')
const Tab1 = () => import('@/components/Tab1.vue')
const Tab2 = () => import('@/components/Tab2.vue')
const Tab3 = () => import('@/components/Tab3.vue')
// const Tab4 = () => import('@/components/Tab4.vue')
const Tab5 = () => import('@/components/Tab5.vue')
const Runway = () => import('@/components/Runway.vue')
const Worktemp = () => import('@/components/Worktemp.vue')



Vue.use(VueRouter)

const routes = [
    {
        path: '/get-to-know-me',
        name: 'Home',
        component: Home
    },
    {
        path: '/',
        name: 'ShowOff',
        component: ShowOff,
        children: [
            {
                path: "",
                name: "ui/ux",
                component: Tab5
            },
            {
                path: "concept_art",
                name: "concept_art",
                component: Tab1
            },
            {
                path: "creatives",
                name: "creatives",
                component: Tab2
            },
            {
                path: "mix-media",
                name: "mix_media",
                component: Tab3
            },
           
        ]
    },
    {
        path: '/what-I-do',
        name: 'Work',
        component: Work
    },
    {
        path: '/Uiwork',
        name: 'Uiwork',
        component: Uiwork
    },
      {   path: '/bound',
        name: 'Bound',
        component: Bound
    },
    {   path: '/dhanam',
        name: 'Dhanam',
        component: Dhanam
    },
    {   path: '/PetFood',
        name: 'PetFood',
        component: PetFood
    },
    {   path: '/cobold',
        name: 'Cobold',
        component: Cobold
    },
    {   path: '/zsites',
        name: 'Zsites',
        component: Zsites
    },
    {   path: '/battlestations',
    name: 'Battlestations',
    component: Battlestations
},
{   path: '/vasundhra',
name: 'Vasundhra',
component: Vasundhra
},
{   path: '/swastik',
name: 'Swastik',
component: Swastik
},
    {   path: '/Ecoplore',
    name: 'Ecoplore',
    component: Ecolpore
},
{   path: '/Healinggarden',
name: 'Healinggarden',
component: Healinggarden
},
{   path: '/max',
name: 'Max',
component: Max
},
{   path: '/zsites-landing',
name: 'ZsitesLanding',
component: ZsitesLanding
},
    {
        path: '/runway',
        name: 'Runway',
        component: Runway
    },

    {
        path: '/wallpapers',
        name: 'Wallpapers',
        component: Wallpapers
    },
    {
        path: '/plans',
        name: 'Plans',
        component: Plans
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/worktemp',
        name: 'Worktemp',
        component: Worktemp
    },
    {
        path: '/card-demo',
        name: 'CardDemo',
        component: CardDemo
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
